// Owner: account-settings (plan §9.3). /account opens the profile.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_settings/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/account/profile', replace: true });
  },
});
